import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Button } from '../../../subkit-ui';
import { TWInput } from '../../TWInput';
import { AcceptTerms } from '../../AcceptTerms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var BookingConfirmationSummary = function BookingConfirmationSummary(_ref) {
  var loading = _ref.loading,
      providerService = _ref.providerService,
      isPaid = _ref.isPaid,
      customerEntitled = _ref.customerEntitled,
      userAgreedToSubkitTerms = _ref.userAgreedToSubkitTerms,
      userNameExists = _ref.userNameExists,
      userId = _ref.userId,
      onConfirmation = _ref.onConfirmation,
      updateUser = _ref.updateUser,
      grantorType = _ref.grantorType,
      existingServiceSubscription = _ref.existingServiceSubscription;

  var _useState = useState({
    firstName: '',
    lastName: ''
  }),
      userInfo = _useState[0],
      setUserInfo = _useState[1];

  var _useState2 = useState(true),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  useEffect(function () {
    if (!userNameExists) {
      setIsValid(false);
    }
  }, [userNameExists]);

  var handleButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              payload = {};

              if (userInfo.firstName) {
                payload.firstName = userInfo.firstName;
              }

              if (userInfo.lastName) {
                payload.lastName = userInfo.lastName;
              }

              payload.agreedToTerms = true;

              if (isEmpty(payload)) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return updateUser(userId, payload);

            case 8:
              onConfirmation(receiveServiceEmails);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleButtonClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleUserInfoChange = function handleUserInfoChange(event) {
    var nextUserInfo = _objectSpread(_objectSpread({}, userInfo), {}, _defineProperty({}, event.target.name, event.target.value));

    setUserInfo(nextUserInfo);
    updateValidity(nextUserInfo);
  };

  var updateValidity = function updateValidity(validationInfo) {
    var validity = _objectSpread(_objectSpread({}, userInfo), validationInfo);

    var nextIsValid;

    if (!userNameExists) {
      nextIsValid = !!validity.firstName && !!validity.lastName;
    }

    setIsValid(nextIsValid);
  };

  var _useState3 = useState(false),
      receiveServiceEmails = _useState3[0],
      setReceiveServiceEmails = _useState3[1];

  var _useState4 = useState(false),
      acceptServiceTerms = _useState4[0],
      setAcceptServiceTerms = _useState4[1];

  var handleAcceptServiceTerms = function handleAcceptServiceTerms() {
    setAcceptServiceTerms(!acceptServiceTerms);
    updateValidity({
      acceptServiceTerms: !acceptServiceTerms
    });
  };

  var handleReceiveServiceEmails = function handleReceiveServiceEmails() {
    setReceiveServiceEmails(!receiveServiceEmails);
  };

  var buttonText = loading ? 'Booking Session...' : 'Book Session';
  return /*#__PURE__*/_jsxs("div", {
    children: [isPaid && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "text-base font-medium mb-0 md:mb-4 text-center md:text-left md:text-lg md:font-semibold",
        children: "Your subscription includes this session."
      }), /*#__PURE__*/_jsx("p", {
        className: "text-base text-neutral-500 mb-6 hidden md:block",
        children: "To book, click or tap the button below. You won\u2019t be charged for this session."
      })]
    }), !userNameExists && /*#__PURE__*/_jsxs("div", {
      className: "flex w-full mb-4",
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-1/2 pr-2.5",
        children: /*#__PURE__*/_jsx(TWInput, {
          format: "rounded",
          label: "First Name",
          placeholder: "Jacob",
          name: "firstName",
          value: userInfo.firstName,
          onChange: handleUserInfoChange,
          onBlur: updateValidity
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "w-1/2 pl-2.5",
        children: /*#__PURE__*/_jsx(TWInput, {
          format: "rounded",
          label: "Last Name",
          placeholder: "Andrews",
          name: "lastName",
          value: userInfo.lastName,
          onChange: handleUserInfoChange,
          onBlur: updateValidity
        })
      })]
    }), (!customerEntitled || !isPaid && !grantorType && !existingServiceSubscription) && /*#__PURE__*/_jsx(AcceptTerms, {
      handleAcceptServiceTerms: handleAcceptServiceTerms,
      handleReceiveServiceEmails: handleReceiveServiceEmails,
      receiveServiceEmails: receiveServiceEmails,
      acceptServiceTerms: acceptServiceTerms,
      providerService: providerService,
      userAgreedToSubkitTerms: userAgreedToSubkitTerms,
      isFree: isPaid ? false : true
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4 md:mt-14 mb-8 md:w-3/5 lg:w-1/2",
      children: /*#__PURE__*/_jsx(Button, {
        text: buttonText,
        "data-cy": "confirmation-summary-submit",
        size: "lg",
        icon: "check",
        iconType: "solid",
        disabled: userNameExists ? existingServiceSubscription ? loading : !acceptServiceTerms : !isValid || loading || !acceptServiceTerms,
        onClick: handleButtonClick
      })
    })]
  });
};
BookingConfirmationSummary.defaultProps = {
  customerEntitled: false
};